module.exports = __webpack_public_path__ + "img/chevron_black_right@2x.67645cc8.png";